import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useEffect, useState } from 'react';
import Portal from '@reach/portal';
import { Button, Switch } from '@chakra-ui/react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import AnimateHeight from 'react-animate-height';
import { useFormState } from 'react-use-form-state';
import { GlobalContext } from '@interness/web-core/src/providers';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';
import * as S from './styles';
import { Link } from '../../elements';
import Spacer from '../../structure/Spacer/Spacer';
import { Header as RowHeader } from '../../structure/MoreExpander/styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ConsentRow = _ref => {
  let {
    consent,
    state,
    setState
  } = _ref;
  const [formState, {
    checkbox
  }] = useFormState();
  const {
    0: height,
    1: setHeight
  } = useState(0);
  const toggle = () => {
    setHeight(height === 0 ? 'auto' : 0);
  };
  useEffect(() => {
    let localState = _objectSpread({}, state);
    localState[consent.function_id] = formState.values[consent.function_id];
    setState(localState);
  }, [formState.values]);
  return ___EmotionJSX("div", null, ___EmotionJSX(RowHeader, {
    height: height,
    onClick: toggle
  }, height !== 0 ? ___EmotionJSX(FaAngleUp, null) : ___EmotionJSX(FaAngleDown, null), ___EmotionJSX("b", {
    style: {
      marginRight: 'auto',
      paddingLeft: '10px'
    }
  }, consent.display_name), ___EmotionJSX(Switch, _extends({}, checkbox(consent.function_id), {
    colorScheme: "brand",
    defaultChecked: consent.consentGiven,
    isDisabled: consent.locked
  }))), ___EmotionJSX(AnimateHeight, {
    height: height,
    duration: 500,
    style: {
      borderBottom: `1px solid #efefef`
    }
  }, ___EmotionJSX("div", {
    style: {
      padding: '0 0 10px 0'
    }
  }, ___EmotionJSX("p", null, consent.description), ___EmotionJSX(Link, {
    to: consent.link
  }, "Zur Datenschutzerkl\xE4rung"))));
};
const CookieConsent = _ref2 => {
  let {
    showInPortal
  } = _ref2;
  const {
    0: hasMounted,
    1: setHasMounted
  } = useState(false);
  const {
    userConsents,
    userConsentDispatcher,
    showCookieBanner,
    setShowCookieBanner
  } = useContext(GlobalContext);
  let initialFormState = userConsents.map(consent => ({
    [consent.function_id]: consent.consentGiven
  }));
  initialFormState = initialFormState.reduce((result, item) => {
    const key = Object.keys(item)[0];
    result[key] = item[key];
    return result;
  }, {});
  const {
    0: formState,
    1: setFormState
  } = useState(initialFormState);
  const onAcceptAll = () => {
    let newState = formState;
    Object.keys(formState).forEach(field => newState[field] = true);
    setFormState(newState);
    const newConsents = userConsents.map(consent => {
      return _objectSpread(_objectSpread({}, consent), {}, {
        consentGiven: formState[consent.function_id]
      });
    });
    userConsentDispatcher({
      type: 'save',
      payload: newConsents
    });
    setShowCookieBanner(false);
  };
  const onAcceptSelection = () => {
    const newConsents = userConsents.map(consent => {
      return _objectSpread(_objectSpread({}, consent), {}, {
        consentGiven: formState[consent.function_id]
      });
    });
    userConsentDispatcher({
      type: 'save',
      payload: newConsents
    });
    setShowCookieBanner(false);
  };
  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true);
    }
    if (window._paq) {
      const matomoConsent = userConsents.find(consent => consent.function_id === 'matomo').consentGiven;
      if (matomoConsent) {
        window._paq.push(['rememberConsentGiven']);
      } else {
        window._paq.push(['forgetCookieConsentGiven']);
      }
    }
  }, [userConsents, hasMounted]);
  if (!showCookieBanner) {
    return null;
  }
  if (!hasMounted) {
    return null;
  }
  return ___EmotionJSX(ConditionalWrapper, {
    condition: showInPortal,
    wrapper: children => ___EmotionJSX(Portal, null, children)
  }, ___EmotionJSX(S.Banner, null, ___EmotionJSX("h3", null, "Cookies ", ___EmotionJSX("span", {
    role: "img",
    "aria-label": "Cookie"
  }, "\uD83C\uDF6A")), userConsents.map(consent => ___EmotionJSX(ConsentRow, {
    key: consent.function_id,
    consent: consent,
    setState: setFormState,
    state: formState
  })), ___EmotionJSX(Spacer, {
    height: 10
  }), ___EmotionJSX("div", {
    className: "int-buttons"
  }, ___EmotionJSX(Button, {
    variant: "ghost",
    colorScheme: "brand",
    onClick: onAcceptSelection
  }, "Ausgew\xE4hlte Cookies erlauben"), ___EmotionJSX(Button, {
    colorScheme: "brand",
    onClick: onAcceptAll
  }, "Alle Cookies erlauben"))));
};
export default CookieConsent;